import {createContext, useEffect, useRef, useState} from 'react'
import {IUser, IUserContext} from './types/userTypes'
import {useMutation} from '@apollo/client'
import {VERIFY_TOKEN} from '../graphql/mutations/loginMutation'
import {IVerifyToken} from '../graphql/types/loginTypes'

export const UserContext = createContext({} as IUserContext)

export const UserProvider = ({children}: {children: React.ReactNode}) => {
  const [state, setState] = useState<{user: null | IUser; isLoading: boolean}>({
    user: null,
    isLoading: true,
  })
  const [gqlVerify, {data, error}] = useMutation<IVerifyToken>(VERIFY_TOKEN)
  const render = useRef(0)
  const login = (user: IUser) => {
    localStorage.setItem('token', user.tokenAuth.token)
    localStorage.setItem('user', JSON.stringify(user))
    setState({
      user,
      isLoading: false,
    })
  }
  const logout = () => {
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    setState({
      user: null,
      isLoading: false,
    })
  }
  useEffect(() => {
    const token = window.localStorage.getItem('token')
    if (!token) {
      return setState({user: null, isLoading: false})
    }

    if (render.current === 0) {
      render.current = 1
      gqlVerify({
        variables: {
          token,
        },
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (data) {
      if (data.verifyToken && data.verifyToken.payload) {
        const date = data.verifyToken.payload.exp

        const fechaActual = Date.now()

        // Obtiene la fecha de vencimiento del token en milisegundos (suponiendo que el valor proporcionado es en segundos)
        const fechaVencimientoToken = date * 1000

        // Calcula la diferencia en milisegundos entre la fecha de vencimiento y la fecha actual
        const diferencia = fechaVencimientoToken - fechaActual

        // Convierte la diferencia en minutos
        const minutosRestantes = Math.floor(diferencia / (1000 * 60))

        if (minutosRestantes <= 30) {
          return logout()
        }
        const strUser = localStorage.getItem('user')
        if (!strUser) return logout()
        const userObj = JSON.parse(strUser) as IUser
        setState({
          user: userObj,
          isLoading: false,
        })
      } else {
        logout()
      }
    }
  }, [data])

  useEffect(() => {
    if (error) {
      console.log('error', error)
      logout()

      window.localStorage.removeItem('token')
      window.localStorage.removeItem('user')
    }
  }, [error])
  return <UserContext.Provider value={{...state, login, logout}}>{children}</UserContext.Provider>
}
